import React, { useState, useEffect } from "react";
import ResponseMsg2 from '../../general/ResponseMsg2'
import { AiOutlineSearch } from 'react-icons/ai';
import HeadingArea from "../../general/HeadingArea";
import { FaCheckCircle, FaFileImage, FaFilePdf } from "react-icons/fa";
import { MdDisabledVisible } from 'react-icons/md';
import { BiSolidReport } from "react-icons/bi";
import { useNavigate } from "react-router-dom";

const ListHomework = ({ setLoading }) => {
  const [selectedClassId, setSelectedClassId] = useState('');
  const [selectedSection, setSelectedSection] = useState('');
  const [selectedSubject, setSelectedSubject] = useState('');
  const [academicYears, setAcademicYears] = useState([]);
  const [selectedAY, setSelectedAY] = useState('');
  const [classes, setClasses] = useState([]);
  const [availableSections, setAvailableSections] = useState([]);
  const [subjects, setSubjects] = useState([]);
  const [homeworkList, setHomeworkList] = useState([]);
  const [response2, setResponse2] = useState({ message: '', status: 'success' });
    const [searchTerm, setSearchTerm] = useState('');
    const [showDisable, setShowDisable] = useState(false);
    const [selectedHw, setSelectedHw] = useState('');
  const navigate = useNavigate();


  // Fetch Academic Years
  const fetchAcademicYears = async () => {
    setLoading(true);
    try {
      const res = await fetch('https://api.kcian.in/get-academic-years');
      if (res.ok) {
        const data = await res.json();
        setAcademicYears(data);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  // Fetch Classes
  const fetchClasses = async () => {
    setLoading(true);
    try {
      const res = await fetch('https://api.kcian.in/get-classes');
      if (res.ok) {
        const data = await res.json();
        setClasses(data);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  // Update available sections when class changes
  useEffect(() => {
    if (selectedClassId) {
      const cls = classes.find(c => c.id === Number(selectedClassId));
      if (cls && cls.sections) {
        const sectionsArray = cls.sections.split(',').map(s => s.trim()).filter(s => s !== '');
        setAvailableSections(sectionsArray);
      } else {
        setAvailableSections([]);
      }
      setSelectedSection('');
      setSubjects([]); // Clear subjects when class changes
      setSelectedSubject('');
    } else {
      setAvailableSections([]);
      setSelectedSection('');
      setSubjects([]);
      setSelectedSubject('');
    }
  }, [selectedClassId, classes]);

  // Fetch subjects when classId and section are selected
  useEffect(() => {
    const fetchSubjects = async () => {
      if (!selectedClassId || !selectedSection) {
        setSubjects([]);
        return;
      }

      setLoading(true);
      try {
        const res = await fetch(`https://api.kcian.in/fetch-assigned-subject?class_id=${selectedClassId}&section=${selectedSection}`);
        if (res.ok) {
          const data = await res.json();
          if (data.length > 0) {
            setSubjects(data);
            setResponse2({ message: 'Assigned Subjects Fetched Successfully.', status: 'success' });
          } else {
            setSubjects([]);
            setResponse2({ message: 'No Subjects Assigned for this Class & Section.', status: 'error' });
          }
        } else {
          setResponse2({ message: 'Failed to fetch subjects.', status: 'error' });
        }
      } catch (error) {
        console.error(error);
      } finally {
        setLoading(false);
        setTimeout(() => setResponse2({ message: '', status: '' }), 3000);
      }
    };

    fetchSubjects();
  }, [selectedClassId, selectedSection, setLoading]);

  // Fetch Academic Years and Classes on mount
  useEffect(() => {
    fetchAcademicYears();
    fetchClasses();
  }, []);

  // Search handler for homework
  const handleSearch = async (e) => {
    e.preventDefault();

    if (!selectedClassId || !selectedSubject) {
            setResponse2({ message: 'Please Select both Class & Subject', status: 'error' });
      return;
    }

    setLoading(true);
    try {
      const params = new URLSearchParams();
      params.append('class_id', selectedClassId);
      params.append('sub_id', selectedSubject);
      params.append('year', selectedAY);
      if (selectedSection) params.append('section', selectedSection);

      const url = `https://api.kcian.in/get-homework?${params.toString()}`;
      const res = await fetch(url);
      if (res.ok) {
        const data = await res.json();
        setHomeworkList(data);
      } else {
        setHomeworkList([]);
            setResponse2({ message: 'No Homework given.', status: 'error' });
      }
    } catch (error) {
      console.error(error);
      setHomeworkList([]);
    } finally {
      setLoading(false);
    }
  };


      const formatDate = (dateString) => {
        const date = new Date(dateString);

        const day = String(date.getDate()).padStart(2, "0");
        const month = String(date.getMonth() + 1).padStart(2, "0");
        const year = date.getFullYear();

        const hours = String(date.getHours()).padStart(2, "0");
        const minutes = String(date.getMinutes()).padStart(2, "0");

        return `${day}-${month}-${year} `;
    };



    const filteredList = homeworkList.filter((r) => {
    const term = searchTerm.toLowerCase();
    const matchesSearch = 
        (r.description?.toLowerCase() || '').includes(term) ||
        (r.marks?.toLowerCase() || '').includes(term)

    return matchesSearch;
});

const handleReport = (item) => {
  navigate('/admin/homework-report', { state: { item } });
};

const handleShowDisable = (item) => {
  setShowDisable(true);
  setSelectedHw(item);
}


              const handleDisable = async (hwId) => {
                const newStatus = selectedHw.status == 'Enabled' ? 'Disabled' : 'Enabled';


                setLoading(true);
    try {
const response = await fetch(`https://api.kcian.in/disable-homework/${hwId}`, {
  method: 'PUT',
  headers: {
    'Content-Type': 'application/json',
  },
  body: JSON.stringify({ status: newStatus }),
});

                setLoading(false);

      if (response.ok) {
setHomeworkList((prevData) =>
        prevData.map((hw) => (hw.id == hwId ? { ...hw, status: newStatus } : hw))
      );
              setShowDisable(false);
        setResponse2({ message: 'Homework Disabled!', status: 'success' });
        setTimeout(() => {
          setResponse2('');
        }, 3000);
      } else {
                setResponse2({ message: 'Something Went Wrong. Please try again.', status: 'error' });
        setTimeout(() => {
          setResponse2('');
        }, 3000);   
      }
    } catch (error) {
                        setLoading(false);

      console.error('Error deleting data:', error);
    }
  };


  return (
    <>
    <section className="py-4">
      <div className="px-4">
        <HeadingArea message1="Homework" message2="List" />

        {response2.message && <ResponseMsg2 message={response2.message} status={response2.status} />}

        <form onSubmit={handleSearch} className="profile-card">
          <span className="profile-heading">Select Criteria</span>

          <div className="row mt-3">

            <div className="col-lg-3 col-md-6 col-12 mb-4">
              <div className="profile-input-area">
                <label className="profile-badge">Select AY*</label>
                <select
                  className="profile-input"
                  value={selectedAY}
                  onChange={(e) => setSelectedAY(e.target.value)}
                  required
                >
                  <option value="">-- Select Academic Year --</option>
                  {academicYears.map((ay) => (
                    <option key={ay.year} value={ay.year}>
                      {ay.year} --- {ay.title}
                    </option>
                  ))}
                </select>
              </div>
            </div>

            <div className="col-lg-3 col-md-6 col-12 mb-4">
              <div className="profile-input-area">
                <label className="profile-badge">Select Class*</label>
                <select
                  className="profile-input"
                  value={selectedClassId}
                  onChange={(e) => setSelectedClassId(e.target.value)}
                  required
                >
                  <option value="">-- Select Class --</option>
                  {classes.map((cls) => (
                    <option key={cls.id} value={cls.id}>
                      {cls.class_name}
                    </option>
                  ))}
                </select>
              </div>
            </div>

            <div className="col-lg-3 col-md-6 col-12 mb-4">
              <div className="profile-input-area">
                <label className="profile-badge">Select Section*</label>
                <select
                  className="profile-input"
                  value={selectedSection}
                  onChange={(e) => setSelectedSection(e.target.value)}
                  required
                  disabled={availableSections.length === 0}
                >
                  <option value="">-- Select Section --</option>
                  {availableSections.map((section, idx) => (
                    <option key={idx} value={section}>
                      {section}
                    </option>
                  ))}
                </select>
              </div>
            </div>

            <div className="col-lg-3 col-md-6 col-12 mb-4">
              <div className="profile-input-area">
                <label className="profile-badge">Subjects*</label>
                <select
                  className="profile-input"
                  value={selectedSubject}
                  onChange={(e) => setSelectedSubject(e.target.value)}
                  required
                  disabled={subjects.length === 0}
                >
                  <option value="">-- Select Subject --</option>
                  {subjects.map((subj) => (
                    <option key={subj.id} value={subj.sub_id}>
                      {subj.sub_name} &nbsp;&nbsp;---&nbsp;&nbsp; {subj.sub_code}
                    </option>
                  ))}
                </select>
              </div>
            </div>

          </div>

          <div className="text-end">
            <button type="submit" className="profile-btn2">
              <AiOutlineSearch /> Search
            </button>
          </div>
        </form>

          <div className="profile-card mt-3">

            <div className="d-md-flex d-sm-flex justify-content-between mb-2">
              <span className="profile-heading align-content-center">Homework List</span>

              <div className="profile-input-area ms-auto col-lg-3 border-0">
                <input
                  type="text"
                  name="search"
                  className="profile-input border-bottom rounded-0"
                  placeholder="Search..."
        value={searchTerm}
        onChange={(e) => setSearchTerm(e.target.value)}
                />
              </div>
            </div>

            <div className="table-responsive my-3">
              <table className="table w-100">
                <thead className="account-thead rounded-4">
                    <th className="rounded-start-4">S No</th>
                    <th>Description</th>
                    <th>Marks</th>
                    <th>Attachment</th>
                    <th>Homework Date</th>
                    <th>Submission Date</th>
                    <th className="rounded-end-4">Activity</th>
                </thead>
                <tbody>
                  {filteredList.length > 0 ? (
                    filteredList.map((item, index) => {
                      // Get subject name from subjects list by matching subject id
                      const subjectName = subjects.find(s => s.id === item.subject_id)?.sub_name || 'N/A';

                      return (
                        <tr key={item.id} className="account-tr">
                          <td>{index + 1}</td>
                          <td>{item.description}</td>
                          <td>{item.marks || '--'}</td>
                                                                      <td>
                                                {item.file ? (() => {
                                                    // Extract file extension
                                                    const ext = item.file.split('.').pop().toLowerCase();

                                                    const imageExts = ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp'];

                                                    const handleClick = () => {
                                                        window.open(`https://api.kcian.in/inUploads/${item.file}`, '_blank');
                                                    };

                                                    if (ext === 'pdf') {
                                                        return <FaFilePdf style={{ cursor: 'pointer', color: 'red' }} size={21} onClick={handleClick} title="View Document" />;
                                                    } else if (imageExts.includes(ext)) {
                                                        return <FaFileImage style={{ cursor: 'pointer', color: 'purple' }} size={21} onClick={handleClick} title="View Image" />;
                                                    } else {
                                                        return '--';
                                                    }
                                                })() : '--'}
                                            </td> 
                          <td>{formatDate(item.homework_date)}</td>
                          <td>{formatDate(item.submission_date)}</td>

                          <td>            
                              <BiSolidReport className="account-icon1 me-2" onClick={() => handleReport(item)} />
                            {item.status == 'Enabled' ? 
                            <MdDisabledVisible className='account-icon2' title='Disable' onClick={() => handleShowDisable(item)} />
                            :                                          
                            <FaCheckCircle className='account-icon2' title='Enable' onClick={() => handleShowDisable(item)} /> }
</td>                        </tr>
                      );
                    })
                  ) : (
                    <tr className="account-tr text-center">
                      <td colSpan="7">No records found.</td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>

          </div>
      </div>
    </section>



    {showDisable && (
      <>

        <section className='ins-dialog'>
          <div className='ins-dialog-inner col-lg-10 col-12 animate__animated animate__fadeInDown mx-auto' onClick={(e) => e.stopPropagation()}>

            <p className='ins-dialog-heading text-danger'>{selectedHw.status == 'Enabled' ? 'Disable' : 'Enable'} This Homework!</p>

<div className='table-responsive mb-4'>
<table className='w-100'>

<thead className='account-thead'>
    <th className='rounded-start-4'>Description</th>
                    <th>Marks</th>
                    <th>Attachment</th>
                    <th>Homework Date</th>
    <th className='rounded-end-4'>Submission Date</th>
</thead>

<tr className='account-tr'>
                          <td>{selectedHw.description}</td>
                          <td>{selectedHw.marks || '--'}</td>
                                                                      <td>
                                                {selectedHw.file ? (() => {
                                                    // Extract file extension
                                                    const ext = selectedHw.file.split('.').pop().toLowerCase();

                                                    const imageExts = ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp'];

                                                    const handleClick = () => {
                                                        window.open(`https://api.kcian.in/inUploads/${selectedHw.file}`, '_blank');
                                                    };

                                                    if (ext === 'pdf') {
                                                        return <FaFilePdf style={{ cursor: 'pointer', color: 'red' }} size={21} onClick={handleClick} title="View Document" />;
                                                    } else if (imageExts.includes(ext)) {
                                                        return <FaFileImage style={{ cursor: 'pointer', color: 'purple' }} size={21} onClick={handleClick} title="View Image" />;
                                                    } else {
                                                        return '--';
                                                    }
                                                })() : '--'}
                                            </td> 
                          <td>{formatDate(selectedHw.homework_date)}</td>
                          <td>{formatDate(selectedHw.submission_date)}</td>
                      </tr>

</table>
</div>

            <button className='profile-btn me-2' onClick={() => handleDisable(selectedHw.id)}>{selectedHw.status == 'Enabled' ? 'Disable' : 'Enable'}</button>
            <button className='profile-btn2' onClick={() => setShowDisable(false)}>Go Back</button>


</div> 
</section>
      </>
    )}


</>
  );
};

export default ListHomework;
